import clsx from "clsx";
import { FC, forwardRef, LegacyRef } from "react";

import { CardProps, SeparatorProps } from "./Card.types";
import styles from "./Card.module.scss";

const Title = ({ children, className, style }: CardProps) => (
  <h2 className={clsx(styles.title, className)} style={style}>
    {children}
  </h2>
);

const Separator = ({ className, style, isFullWidth }: SeparatorProps) => (
  <div
    style={style}
    className={clsx(
      styles.separator,
      { [styles.separatorFullWidth]: isFullWidth },
      className
    )}
  />
);

const Footer = ({ children, className, style, as: Tag = "div" }: CardProps) => (
  <Tag className={clsx(styles.footer, className)} style={style}>
    {children}
  </Tag>
);

export const CardComponent = forwardRef<
  HTMLDivElement | HTMLLabelElement,
  CardProps
>(({ children, className, as: Tag = "div", ...props }, ref) => (
  <Tag
    {...props}
    ref={ref as LegacyRef<HTMLDivElement> as any}
    className={clsx(styles.card, className)}
  >
    {children}
  </Tag>
));

export const Card = CardComponent as unknown as FC<CardProps> & {
  Title: typeof Title;
  Separator: typeof Separator;
  Footer: typeof Footer;
};

Card.Title = Title;
Card.Separator = Separator;
Card.Footer = Footer;
